import { render, staticRenderFns } from "./RawMaterialSupplierDetail.vue?vue&type=template&id=65acd7cf&scoped=true"
import script from "./RawMaterialSupplierDetail.vue?vue&type=script&lang=js"
export * from "./RawMaterialSupplierDetail.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialSupplierDetail.vue?vue&type=style&index=0&id=65acd7cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65acd7cf",
  null
  
)

export default component.exports